<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/contact/form">写真を投稿する</router-link></li>
        </ul>
      </div>
    </div>
    <div class="contact">
      <div class="contact__title">
        <div class="container">
          <h2>MY FAVORITE THINGS<span>私のお気に入り</span></h2>
          <h2>写真を投稿する</h2>
          <ul class="contact__process step3">
            <li>
              <span>1.入力</span>
            </li>
            <li>
              <span>2.確認</span>
            </li>
            <li class="active">
              <span>3.完了</span>
            </li>
          </ul>
          <p style="text-align: center;">写真の投稿を受け付けました</p>
          <div class="contact__title__button">
            <router-link class="btn" to="/">TOPに戻る</router-link>
          </div>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import { RouterLink } from 'vue-router';
import { metaData } from '@/utils/helper';
import indexedDB from '@/utils/indexedDB';

export default {
  name: 'MyfavoritethingsFormComplete',
  props: ['dataComplete'],
  created() {
    if (sessionStorage.getItem('token') == null || sessionStorage.getItem('validated_inputform') == null) {
      this.clearSession();
      this.$router.push({
        name: 'Myfavoritethings',
        params: {
          isScrollToLogin: true
        }
      });
    }

    this.clearSession();
    metaData(
      `写真を投稿する | HARUMIFLAGタウンポータル`,
      '中央区晴海・HARUMIFLAGのMY FAVORITE THINGS 写真を投稿するページです。',
      'HARUMIFLAGタウンポータル',
      'website'
    )
  },

  methods: {
    clearSession() {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('validated_inputform');
      sessionStorage.removeItem('validated_inputform_data');
      indexedDB.clear();
    }
  }
}
</script>